module.exports = __webpack_public_path__ + "img/pophop.671b2530.png";